"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _immutable = require("immutable");

var _propertyTranslator = require("property-translator/propertyTranslator");

var _Constants = require("composer-plugins/plugins/questionAndAnswer/Constants");

var _DEFAULT_OBJECT_PROPE;

var DEFAULT_OBJECT_PROPERTIES = (_DEFAULT_OBJECT_PROPE = {}, (0, _defineProperty2.default)(_DEFAULT_OBJECT_PROPE, _Constants.ObjectTypes.CONTACT, []), (0, _defineProperty2.default)(_DEFAULT_OBJECT_PROPE, _Constants.ObjectTypes.COMPANY, []), (0, _defineProperty2.default)(_DEFAULT_OBJECT_PROPE, _Constants.ObjectTypes.DEAL, []), (0, _defineProperty2.default)(_DEFAULT_OBJECT_PROPE, _Constants.ObjectTypes.TICKET, []), _DEFAULT_OBJECT_PROPE);

function translateProperty(property) {
  return property.update('label', _propertyTranslator.propertyLabelTranslator);
}

function translateGroups(groups) {
  return groups.map(function (group) {
    return group.withMutations(function (mutable) {
      return mutable.update('displayName', _propertyTranslator.propertyLabelTranslator).update('properties', function (properties) {
        return properties.map(translateProperty);
      });
    });
  });
}

function flattenGroups(groups) {
  return groups.reduce(function (properties, group) {
    return group.get('properties').reduce(function (propertyMap, property) {
      return propertyMap.set(property.get('name'), translateProperty(property));
    }, properties);
  }, (0, _immutable.Map)());
}

function transformProperties(properties) {
  return (0, _immutable.fromJS)(properties).map(function (propertyGroups) {
    return (0, _immutable.Map)({
      properties: flattenGroups(propertyGroups),
      groups: translateGroups(propertyGroups)
    });
  });
}

var _default = (0, _memoize.default)(function (properties) {
  if (!properties) {
    return transformProperties(DEFAULT_OBJECT_PROPERTIES);
  }

  return transformProperties(properties);
});

exports.default = _default;
module.exports = exports.default;